import React from 'react';

import { SVGProps } from './SVGProps';

const Check = ({ fill = 'none', width = '16', height = '16', stroke = 'white' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Check;
